import React from 'react';
import styles from './AFITrendArrow.module.scss';

interface AFITrendArrowProps {
  trend: 'up' | 'down' | 'stable';
  delta: number;
  showDelta?: boolean;
}

const TREND_CONFIG: Record<
  'up' | 'down' | 'stable',
  { symbol: string; color: string; getTooltip: (delta: number) => string }
> = {
  up:     { symbol: '↑', color: '#1a7a4a', getTooltip: (d) => `+${d} pts (14gg)` },
  down:   { symbol: '↓', color: '#991b1b', getTooltip: (d) => `-${d} pts (14gg)` },
  stable: { symbol: '→', color: 'var(--c-text-1)', getTooltip: (d) => `Stabile (±${d} pts)` },
};

const AFITrendArrow: React.FC<AFITrendArrowProps> = ({
  trend,
  delta,
  showDelta = false,
}) => {
  const { symbol, color, getTooltip } = TREND_CONFIG[trend];
  const tooltipText = getTooltip(Math.abs(delta));

  const arrowStyle: React.CSSProperties = { color };
  const deltaStyle: React.CSSProperties = { color };

  const deltaText =
    trend === 'up'
      ? `+${Math.abs(delta)} pts`
      : trend === 'down'
      ? `-${Math.abs(delta)} pts`
      : `±${Math.abs(delta)} pts`;

  return (
    <span className={styles.wrapper} title={tooltipText}>
      <span className={styles.arrow} style={arrowStyle} aria-label={tooltipText}>
        {symbol}
      </span>
      {showDelta && (
        <span className={styles.delta} style={deltaStyle}>
          {deltaText}
        </span>
      )}
    </span>
  );
};

export default AFITrendArrow;
